/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import PuvTaggingContainer from './container/PuvTaggingContainer';
import TricycleTaggingContainer from './container/TricycleTaggingContainer';

function RequirementsTabContainer({ match, pathName, permissions }) {
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row border-bottom-row">
          <ul className="nav nav-tabs sub-tab-borongan">
            {Acl(permissions, ['VIEW REQUIREMENTS TAGGING (PUV)']) && (
              <li className="nav-item">
                <Link
                  to="/special-permit/settings/requirements-tagging"
                  className={`nav-link sub-tab py-3 px-5 ${pathName.indexOf(
                    '/special-permit/settings/requirements-tagging/puv'
                  ) > -1
                    ? 'selected'
                    : ''
                    }`}
                >
                  PUV
                </Link>
              </li>
            )}
            {Acl(permissions, ['VIEW REQUIREMENTS TAGGING (TRICYCLE)']) && (
              <li className="nav-item">
                <Link
                  to="/special-permit/settings/requirements-tagging/tricycle"
                  className={`nav-link sub-tab py-3 px-5 ${pathName.indexOf(
                    '/special-permit/settings/requirements-tagging/tricycle'
                  ) > -1
                    ? 'selected'
                    : ''
                    }`}
                >
                  Tricycle
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>
      <Switch>
        <Route
          exact
          path={`${match.path}`}
          render={() => <Redirect to={`${match.path}/puv`} />}
        />
        {Acl(permissions, ['VIEW REQUIREMENTS TAGGING (PUV)']) && (
          <Route
            path={`${match.path}/puv`}
            component={PuvTaggingContainer}
          />
        )}
        {Acl(permissions, ['VIEW REQUIREMENTS TAGGING (TRICYCLE)']) && (
          <Route
            path={`${match.path}/tricycle`}
            component={TricycleTaggingContainer}
          />
        )}
      </Switch>
    </React.Fragment>
  );
}

RequirementsTabContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(RequirementsTabContainer);
